import keymirror from 'keymirror';
import { makeActionCreator } from 'utils/reduxUtils/reduxUtils';
import httpActions from 'actions/httpActions/httpActions';
import facebookInviteFriendsActions from 'actions/facebookInviteFriendsActions/facebookInviteFriendsActions';
import { isRequestInFlight } from 'selectors/httpSelectors/httpSelectors';

export const types = keymirror({
  SET_CHARITY: null,
  RESET_CHARITY_SELECTION: null,
  UPDATE_QUERY_TEXT: null,
  CLEAR_QUERY_TEXT: null,
  UPDATE_IS_USER_LOGGED_IN: null,
  UPDATE_AUTH_ACCESS_TOKEN: null,
  UPDATE_AUTH_REFRESH_TOKEN: null,
  PARTICIPANT_PROMISE: null,
  PARTICIPANT_REQUEST_ERROR: null,
  RESET_PROCEED_TO_DONATION_CLICKED: null,
  PROCEED_TO_DONATION_CLICKED: null,
});

const actions = {
  setCharity: makeActionCreator(types.SET_CHARITY, 'charityId'),

  resetCharitySelection: makeActionCreator(types.RESET_CHARITY_SELECTION),

  updateQueryText: makeActionCreator(types.UPDATE_QUERY_TEXT, 'queryText'),

  clearQueryText: makeActionCreator(types.CLEAR_QUERY_TEXT),

  resetProceedToDonationClicked: makeActionCreator(types.RESET_PROCEED_TO_DONATION_CLICKED),

  proceedToDonationClicked: makeActionCreator(types.PROCEED_TO_DONATION_CLICKED),

  confirmFriendsSelection: () => (dispatch, getState) => {
    const state = getState();

    if (!isRequestInFlight('inviteFriends')(state)) {
      dispatch(httpActions.requestMade('inviteFriends'));

      const apiCallback = (response) => {
        dispatch(httpActions.requestSuccess('inviteFriends'));
        if (response && !response.error) {
          dispatch(actions.proceedToDonationClicked());
        }
      };

      const { mainStore, api } = state;
      const fundraisingPageUrl = api.getIn(['normalized', 'result', 'participant', 'pageUrl']);
      const selectedCharityId = mainStore.get('charityId');
      const charityName = api.getIn(['normalized', 'entities', 'charities', `${selectedCharityId}`, 'charityName']);
      const message = `I’m fundraising for ${charityName} on JustGiving. Will you MATCHmyMILES by donating to my cause?`;

      dispatch(facebookInviteFriendsActions.postToFB(fundraisingPageUrl, message, apiCallback));
    }
  },

  updateUserIsLoggedIn: makeActionCreator(types.UPDATE_IS_USER_LOGGED_IN, 'isUserLoggedIn'),
  updateAuthAccessToken: makeActionCreator(types.UPDATE_AUTH_ACCESS_TOKEN, 'accessToken'),
  updateAuthRefreshToken: makeActionCreator(types.UPDATE_AUTH_REFRESH_TOKEN, 'refreshToken'),
  saveParticipantPromise: makeActionCreator(types.PARTICIPANT_PROMISE, 'participantPromise'),
  updateParticipantRequestError: makeActionCreator(types.PARTICIPANT_REQUEST_ERROR, 'participantRequestError'),
};

export default actions;



// WEBPACK FOOTER //
// ./actions/mainActions/mainActions.js